<template>
  <div v-if="!loading">
    <v-row
      class="mt-0"
      justify="center"
    >
      <v-col
        cols="6"
        md="4"
      >
        <v-card
          elevation="1"
          outlined
        >
          <v-card-text class="pt-9">
            <p class="text-h4 text--primary text-center">
              {{ summary.active_companies }}
            </p>

            <p class="text-h6 primary--text text-center">ACTIVE COMPANIES</p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="6"
        md="4"
      >
        <v-card
          elevation="1"
          outlined
        >
          <v-card-text class="pt-9">
            <p class="text-h4 text--primary text-center">
              {{ summary.data_used }}
            </p>
            <p class="text-h6 primary--text text-center">DATA USED</p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="6"
        md="4"
      >
        <v-card
          elevation="1"
          outlined
          ><v-card-text class="pt-9">
            <p class="text-h4 text--primary text-center">
              {{ summary.users_connected }}
            </p>
            <p class="text-h6 primary--text text-center">USERS CONNECTED</p>
          </v-card-text></v-card
        >
      </v-col>
      <v-col
        cols="6"
        md="4"
      >
        <v-card
          elevation="1"
          outlined
          ><v-card-text class="pt-9">
            <p class="text-h4 text--primary text-center">
              {{ summary.ongoing_projects }}
            </p>
            <p class="text-h6 primary--text text-center">ONGOING PROJECTS</p>
          </v-card-text></v-card
        >
      </v-col>
      <v-col
        cols="6"
        md="4"
      >
        <v-card
          elevation="1"
          outlined
          ><v-card-text class="pt-9">
            <p class="text-h4 text--primary text-center">
              {{ summary.operators_connected }}
            </p>

            <p class="text-h6 primary--text text-center">OPERATORS CONNECTED</p>
          </v-card-text></v-card
        >
      </v-col>
      <v-col
        cols="6"
        md="4"
      >
        <v-card
          elevation="1"
          outlined
          ><v-card-text class="pt-9">
            <p class="text-h4 text--primary text-center">
              {{ summary.inspections_realised }}
            </p>
            <p class="text-h6 primary--text text-center">INSPECTIONS CLOSED</p>
          </v-card-text></v-card
        >
      </v-col>
      <v-col
        cols="6"
        md="4"
      >
        <v-card
          elevation="1"
          outlined
          ><v-card-text class="pt-9">
            <p class="text-h4 text--primary text-center">
              {{ summary.identified_non_conformities }}
            </p>

            <p class="text-h6 primary--text text-center">IDENTIFIED NON-CONFORMITIES</p>
          </v-card-text></v-card
        >
      </v-col>
    </v-row>
  </div>
  <div v-else>
    <v-progress-linear></v-progress-linear>
  </div>
</template>

<script>
import AdminServices from "@/services/AdminServices"
export default {
  name: "AdminSummary",
  data() {
    return {
      loading: false,
      summary: {}
    }
  },
  mounted() {
    this.loading = true
    AdminServices.getSummary()
      .then(r => {
        this.summary = r
      })
      .finally(() => (this.loading = false))
  }
}
</script>
